import { Dispatch } from 'react';

import { SORT_ORDER } from 'common/constants';
import { MAPPING_DATA } from 'common/constants/CitationDetails';
import { ENTITY_STATUS } from 'common/constants/TaxonomyConstants';
import { setMappingDrawer } from 'common/store/reducer/commonReducer';
import { setTabIndex } from 'common/store/reducer/mappingDetailsReducer';

import { IRelationshipMappingData } from 'features/HorizonScanning/api/type-def';

/**
 * @method to map the relationship response with object
 * @returns modified data
 */
export const relationshipMappingHandler = (
	mappingData: IRelationshipMappingData[],
) => {
	const data: any = { process: [], control: [], policy: [], risk: [] };
	mappingData?.forEach((obj) => {
		const { childObjectType, childObjectName, childObjectId } = obj;
		const { keyword, idKey, nameKey } = MAPPING_DATA[childObjectType];

		// Check if the keyword exists in the mapping object and the final object
		if (keyword) {
			data[keyword].push({
				[idKey]: childObjectId,
				[nameKey]: childObjectName,
			});
		}
	});
	return data;
};

/**
 * @method to sort based on order
 */
export const sortFieldsHandler = (sortOrder: string) => {
	if (sortOrder === SORT_ORDER.ASCENDING) {
		return SORT_ORDER.DESCENDING;
	} else if (sortOrder === SORT_ORDER.DESCENDING) {
		return SORT_ORDER.ASCENDING;
	}
	return '';
};

/**
 * @method to set state based on entity status
 */
export const renderBasedOnEntityStatus = (
	impactValue: string,
	dispatch: Dispatch<any>,
	sideDrawerState: boolean,
) => {
	if (impactValue === ENTITY_STATUS.IMPACTED) {
		dispatch(setTabIndex('tasks'));
	} else {
		dispatch(setMappingDrawer(!sideDrawerState));
	}
};
